const SITE_URL = "https://www.reignitespirit.com";

export const financialRunwayApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",

  "@id":
    `${SITE_URL}/runway-calculator#software-application`,

  name: "ReigniteSpirit Financial Runway Calculator",

  alternateName: "Financial Runway Calculator",

  url: `${SITE_URL}/runway-calculator`,

  applicationCategory: "FinanceApplication",

  applicationSubCategory:
    "Career Transition Financial Planning Tool",

  operatingSystem: "Web",

  browserRequirements:
    "Requires a modern web browser with JavaScript enabled.",

  description:
    "A web-based calculator that helps users estimate how long their available financial resources may support them during a career transition, reskilling period, resignation or potential job loss.",

  provider: {
    "@id": `${SITE_URL}/#organization`,
  },

  publisher: {
    "@id": `${SITE_URL}/#organization`,
  },

  isAccessibleForFree: true,

  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
    url: `${SITE_URL}/register?plan=free_calculator`,
  },

  featureList: [
    "Financial runway estimation",
    "Monthly expense analysis",
    "Savings and passive income assessment",
    "Career transition planning",
    "Severance and gratuity input support",
    "Inflation consideration",
    "Manual financial data entry",
  ],

  inLanguage: "en",
};